module.exports = __webpack_public_path__ + "img/prices_bg.8beea025.svg";